/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Try_RunningInputs */

const en_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running...`)
};

const zh_hans1_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行中…`)
};

const pt_br2_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executando...`)
};

const es_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutando...`)
};

const fr_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécution...`)
};

const de_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft...`)
};

const ru_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняется...`)
};

const it_endpoint_try_running = /** @type {(inputs: Endpoint_Try_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esecuzione...`)
};

/**
* | output |
* | --- |
* | "Running..." |
*
* @param {Endpoint_Try_RunningInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_running = /** @type {((inputs?: Endpoint_Try_RunningInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_RunningInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_running(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_running(inputs)
	if (locale === "es") return es_endpoint_try_running(inputs)
	if (locale === "fr") return fr_endpoint_try_running(inputs)
	if (locale === "de") return de_endpoint_try_running(inputs)
	if (locale === "ru") return ru_endpoint_try_running(inputs)
	if (locale === "it") return it_endpoint_try_running(inputs)
	return en_endpoint_try_running(inputs)
});